// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1001":"061b2f29","6436":"bc4f06fb"}[chunkId] + ".chunk.css";
};